module.exports = __webpack_public_path__ + "static/media/github.556e5420.png";